import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useEffect, useState } from "react";
import { useUpdateWindhostingWebserver, useWindhostingWebserver, useWindhostingWebserverInfo } from "@hostingbv/lib/src/api/partner/PartnerHooks";
import { Server } from "@hostingbv/lib/src/api/partner/models/Server";
import { WebserverConfig } from "@hostingbv/lib/src/api/partner/models/windhosting/WebserverConfig";
import { webserverConfigExamples } from "@hostingbv/lib/src/api/partner/models/windhosting/WebserverInfo";
import { ValidationError } from "@hostingbv/lib/src/api/ModelFactory";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";

export const WindhostingWebserverConfigModal: FC<{ server: Server }> = ({ server }) => {
  const [config, setConfig] = useState("")
  const [deploymentError, setDeploymentError] = useState("")

  const { data } = useWindhostingWebserver(server.id)
  const { data: info } = useWindhostingWebserverInfo(server.id)
  useEffect(() => setConfig(data?.config?.['server'] ?? ""), [data])

  const { mutate, error } = useUpdateWindhostingWebserver(server.id)
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!
  const save = async () => {
    if (!data) return
    const deployment = await mutate(new WebserverConfig({ ...data.config, server: config }));

    const updatedDeployment = await awaitNextDeploymentFinished(deployment.id)
    if (updatedDeployment?.status === "failed") {
      // @ts-expect-error output is untyped
      setDeploymentError(updatedDeployment?.output?.message ?? 'Invalid configuration')
      throw Error("deployment failed");
    }
  }

  return <>
    <form onSubmit={() => save()} className={""}>
      <div>
        <span className={'text-sm font-medium text-brand-900'}>webserver.conf</span>
        <div className={'border-2 border-slate-200 rounded-sm mt-1 flex flex-col items-stretch'}>
          <textarea
            autoFocus={true}
            className={`outline-hidden text-black rounded-sm font-normal px-2 py-2 h-72 text-xs font-mono`}
            placeholder={info ? webserverConfigExamples[info.component] : ''}
            value={config}
            onChange={(e) => setConfig(e.target.value)}
          />
        </div>
        {error instanceof ValidationError && <div className={"px-3 py-2 bg-red-50 rounded-sm my-4 text-sm text-red-900"}>
          {error.message}
        </div>}
        {deploymentError !== '' && <div className={"px-3 py-2 bg-red-50 rounded-sm my-4 text-sm text-red-900"}>
          {deploymentError}
        </div>}
      </div>
      <ModalFooter text={"Save"} onSubmit={save} />
    </form>
  </>
}
